<template>
  <div class="bloc-category">
    <v-toolbar
      dark
      dense
      color="primary"
      @click="showChildren = !showChildren"
    >
      <v-btn
        class="title-category"
        icon
        @click.stop="showChildren = !showChildren"
      >
        <v-icon>
          {{ showChildren ? 'mdi-menu-down' : 'mdi-menu-right' }}
        </v-icon>
        {{ category.name[userLang] }}
      </v-btn>
      <v-row
        align="center"
        justify="center"
      />
    </v-toolbar>

    <v-container
      v-if="showChildren"
      class="bloc"
    >
      <v-row
        v-if="isEdition || hasActiveActivities"
        class="font-weight-bold bloc-titles"
      >
        <v-col
          cols="2"
          class="title"
        >
          <p>{{ $t('forms.labels.activities') }}</p>
        </v-col>
        <v-col
          class="title"
        >
          <p>{{ $t('forms.labels.frequencies') }}</p>
        </v-col>
        <v-col
          class="title"
        >
          <p>{{ $t('forms.labels.procedure') }}</p>
        </v-col>
        <v-col
          class="title calendar"
          cols="6"
        >
          <p>{{ $t('forms.labels.calendar') }}</p>
        </v-col>
      </v-row>

      <Activities
        v-for="(activity, index) in displayedActivities"
        :key="index"
        :isEdition="isEdition"
        :frequencies="frequencies"
        :activity="activity"
        @updateData="updateCategory"
      />
    </v-container>
  </div>
</template>

<script>
import Activities from '@/views/maintenanceSchedule/Activities';
import { mapGetters } from 'vuex';

export default {
    components: {
        Activities,
    },
    props: {
        category: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
        frequencies: {
            type: Array,
            default: () => [],
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showChildren: true,
            data: {
                category: null,
            },
        };
    },

    computed: {
        ...mapGetters([
            'userLang',
        ]),
        activities() {
            return this.data.category.activities;
        },
        activeActivities() {
            return this.activities.filter(({ active }) => active);
        },
        displayedActivities() {
            return this.isEdition ? this.activities : this.activeActivities;
        },
        hasActiveActivities() {
            return this.activities.some(({ active }) => active);
        },

    },
    watch: {
        show() {
            this.showChildren = this.show;
        },
        category: {
            handler() {
                this.data.category = this.category;
            },
            immediate: true,
        },
    },
    methods: {
        updateCategory(newActivity) {
            this.data.category = {
                ...this.data.category,
                activities: this.data.category.activities.map(activity => (activity.id === newActivity.id ? newActivity : activity)),
            };

            this.$emit('updateData', this.data.category);
        },

    },
};
</script>
<style lang="scss" scoped>
  .title-category {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    border-radius: 0
  }
  @media screen and (max-width: 960px) {
    .title {
      min-width: 250px !important;
    }
    .bloc-titles {
      display: flex;
      flex-direction: column;
      width: 150px;
      height: max-content;
    }
    .bloc {
      display: flex;
      flex-direction: row;
      overflow-x: auto;
      width: 100vh;
      margin-left: 0;
      margin-right: 0;
    }
    .bloc-category {
      width: max-content;
      min-width: 100%;
    }
  }
</style>
